import { ProfileInstance, catchError } from '@/store'
import { FullStory } from '@fullstory/browser'
const version = require('@/../package.json').version

export const state = () => ({
  profile: {
    loggedIn: false,
    isLoading: true,
    initials: 'CC',
    name: '',
    user: {}
  },
  merchant: {
    id: 'xyz123',
    name: 'Pagar.me Inc'
  },
  preferences: ProfileInstance.me.getPreferences()
})

export const mutations = {
  SET_PROFILE (state, profile) {
    state.profile = profile
  },
  SET_MERCHANT (state, merchant) {
    state.merchant = merchant
  },
  SET_USER_PREFERENCES (state, payload) {
    const pref = Object.assign({}, payload)
    ProfileInstance.me.setPreferences(pref)
    state.preferences = payload
  }
}

export const actions = {
  SET_PROFILE ({ commit, dispatch }, data) {
    return ProfileInstance.authorization.get({}, 'hubdash', process.env.VUE_APP_PROFILE_URL)
      .then(profile => {
        profile.loggedIn = true
        profile.isLoading = false
        commit('SET_PROFILE', profile)

        const userInfosToFS = {
          id: profile.user.id,
          displayName: `${profile.user.first_name} ${profile.user.last_name}`,
          email: profile.user.email,
          merchantId_str: profile.merchant ? profile.merchant.id : null,
          merchantName_str: profile.merchant ? profile.merchant.name : null,
          userType_str: profile.merchant ? profile.merchant.type.key : null,
          appVersion_str: version
        }

        if (['production'].includes(process.env.VUE_APP_CORE_ENV)) {
          FullStory('setIdentity', { uid: profile.user.id, userInfosToFS })
        }

        // Appcues
        window.Appcues.identify(
          profile.user.id,
          {
            firstName: profile.user.first_name,
            role: profile.merchant.type.key || null,
            email: profile.user.email,
            version: version,
            companyName: profile.merchant.name || null,
            accountId: profile.merchant.id || null
          }
        )

        return Promise.resolve(profile)
      })
      .catch(e => {
        catchError(e, dispatch)
        const profile = {
          loggedIn: false,
          isLoading: false
        }
        commit('SET_PROFILE', profile)
        return Promise.reject(e)
      })
  },
  SET_MERCHANT ({ commit }, merchant) {
    commit('SET_MERCHANT', merchant)
  },
  LOGOUT ({ commit }, logout = false) {
    commit('SET_PROFILE', { loggedIn: false, isLoading: true })
    return ProfileInstance.authorization.deleteCookies('hubdash', logout)
  },
  SET_LANGUAGE (context, payload) {
    const preferences = Object.assign({}, context.state.preferences)
    preferences.language = payload
    if (context.state.preferences.language !== payload) location.reload()
    context.commit('SET_USER_PREFERENCES', preferences)
  }
}

export default {
  state,
  mutations,
  actions
}
